import * as types from "./mutation-types";
import _ from "lodash";
import { conselho_empty } from "./getters";

export default {
  [types.SET_CONSELHOS](state, payload) {
    state.conselhos = payload;
  },
  [types.SET_CONSELHO](state, payload) {
    payload = _.merge(conselho_empty(), payload);
    state.conselho = payload;
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  },
  [types.SET_LAYOUT](state, payload) {
    state.layout = payload;
  },
};
